
import { FloatingLabel, Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';

import { DeleteIcon, PencilIcon } from '../assets/icons';
import TooltipHover from './TooltilHover';
import useProblema from '../hooks/useProblema';
import FlexCenter from './FlexCenter';


const Problema = () => {

    const { borrarProblemas, cargando, cerrarModal, editarProblemas, formProblemas, guardarProblemas, isOpen,
            llenarFormProblemas, problemasActuales, setFormProblemas, setTieneProblemas, tieneProblemas } = useProblema();

    function tablaProblemas() {
        if ( tieneProblemas ) {
            return (
                <>
                    <Alert variant='success' className='my-4'>
                        Completa los siguientes campos.
                    </Alert>
                    <div className='card card-body'>
                        <Row>
                            <Col xs={12} xl={6}>
                                <FloatingLabel controlId="floatingSelect" label="Indica el tipo de problema">
                                    <Form.Select
                                        aria-label="Tipo de problema"
                                        value={ formProblemas.tipo }
                                        onChange={ e => setFormProblemas({ ...formProblemas, tipo: e.target.value }) }
                                    >
                                        <option>Selecciona una opción</option>
                                        <option value="Auditivo">Auditivo</option>
                                        <option value="Ortopédico">Ortopédico</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} xl={6}>
                                <FloatingLabel
                                    controlId="floatingInput20"
                                    label="Describe el problema"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        placeholder=" "
                                        autoComplete='off'
                                        value={ formProblemas.problema }
                                        onChange={ e => setFormProblemas({ ...formProblemas, problema: e.target.value }) }
                                    />
                                </FloatingLabel>
                            </Col>
                        </Row>
                        <FlexCenter>
                            <Button
                                variant="primary"
                                disabled={ cargando }
                                onClick={ guardarProblemas }
                            >
                                { ( cargando ) ? "Guardando" : "Guardar cambios" }
                            </Button>
                        </FlexCenter>
                    </div>
                    <div className='table-responsive my-4'>
                        <Table bordered hover>
                            <thead>
                                <tr>
                                    <th className='text-center'>Tipo de problema</th>
                                    <th className='text-center'>Descripción</th>
                                    <th className='text-center'>Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                { problemasActuales?.map(( e, i )=> (
                                    <tr key={ i }>
                                        <td className='text-center'>
                                            { e.tipo }
                                        </td>
                                        <td className='text-center'>
                                            { e.problema }
                                        </td>
                                        <td className='text-center'>
                                            <ButtonGroup>
                                                <TooltipHover tooltipText='Editar información'>
                                                    <Button variant='warning' onClick={ () => llenarFormProblemas( e ) }>
                                                        <PencilIcon/>
                                                    </Button>
                                                </TooltipHover>
                                                <TooltipHover tooltipText='Eliminar'>
                                                    <Button variant='danger' onClick={ () => borrarProblemas( e.pk_problema ) }>
                                                        <DeleteIcon/>
                                                    </Button>
                                                </TooltipHover>
                                            </ButtonGroup>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </>
            )
        }
    }



    return (
        <div className="my-4">

            <p className="lead text-center">
                ¿Tienes algún problema auditivo u ortopédico?
            </p>

            <Form.Check
                id = 'tiene_problema'
                type = 'checkbox'
                className = 'd-flex justify-content-center no-select'
                checked = { tieneProblemas }
                onChange = { e => setTieneProblemas( e.target.checked ) }
                label = '&nbsp;&nbsp;Marcar la casilla de ser correcto'
            />

            { tablaProblemas() }

            <Modal
                show={ isOpen }
                onHide={ cerrarModal }
                backdrop="static"
                keyboard={false}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className=''
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Administrar registros</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <Row>
                        <Col xs={12} xl={6}>
                            <FloatingLabel controlId="floatingSelect" label="Indica el tipo de problema">
                                <Form.Select
                                    aria-label="Tipo de problema"
                                    value={ formProblemas.tipo }
                                    onChange={ e => setFormProblemas({ ...formProblemas, tipo: e.target.value }) }
                                >
                                    <option>Selecciona una opción</option>
                                    <option value="Auditivo">Auditivo</option>
                                    <option value="Ortopédico">Ortopédico</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                controlId="floatingInput21"
                                label="Describe el problema"
                                className="mb-3"
                            >
                                <Form.Control
                                    placeholder=" "
                                    autoComplete='off'
                                    value={ formProblemas.problema }
                                    onChange={ e => setFormProblemas({ ...formProblemas, problema: e.target.value }) }
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={ cerrarModal }>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={ editarProblemas } disabled={ cargando }>
                        { ( cargando ) ? "Guardando" : "Guardar cambios" }
                    </Button>
                </Modal.Footer>
            </Modal>

            <hr className='m-5'/>
        </div>
    )
}

export default Problema
